(function () {
  let flickityInstance;

  function initFlickity() {
    const slider = document.querySelector('.product__image-slider');
    if (!slider || typeof Flickity === 'undefined') return;
    flickityInstance = new Flickity(slider, {
      contain: true,
      wrapAround: true,
      pageDots: false
    });
  }
  function updateMedia(variant) {
    if (!variant || !variant.featured_media) return;

    const currentMediaId = variant.featured_media.id;

    const slider = document.querySelector('.product__image-slider');
    if (slider && flickityInstance) {
      const mediaIds = Array.from(slider.querySelectorAll('img'))
        .map((img) => parseInt(img.dataset.mediaId));
      const targetIndex = mediaIds.indexOf(currentMediaId);
      if (targetIndex >= 0) flickityInstance.select(targetIndex);
      return;
    }

    const mediaList = document.querySelector('.product__media-list');
    if (mediaList) {
      mediaList.querySelectorAll('[data-media-id]').forEach((el) => {
        el.style.display = el.dataset.mediaId.includes(currentMediaId) ? 'block' : 'none';
      });
    }
  }

  function initZoomHover() {
    const containers = document.querySelectorAll('.img_producto_container');
    if (!containers.length) return;

    containers.forEach((container) => {
      const img = container.querySelector('.img_producto');
      if (!img) return;

      const scale = parseFloat(container.dataset.scale) || 1.5;

      container.addEventListener('mouseover', () => {
        img.style.transform = `scale(${scale})`;
      });

      container.addEventListener('mouseout', () => {
        img.style.transform = 'scale(1)';
      });

      container.addEventListener('mousemove', (e) => {
        const x = ((e.pageX - container.offsetLeft) / container.offsetWidth) * 50;
        const y = ((e.pageY - container.offsetTop) / container.offsetHeight) * 50;
        img.style.transformOrigin = `${x}% ${y}%`;
      });
    });
  }
  function initZoomIconTrigger() {
    const zoomIcon = document.querySelector('#product-top .single-nav-img svg.customimagezoom');
    if (!zoomIcon) return;

    zoomIcon.addEventListener('click', (e) => {
      e.preventDefault();
      const activeLink = zoomIcon
        .closest('.single-nav-img')
        ?.querySelector('.img_producto_container.is-selected a.fslightbox');
      if (activeLink) activeLink.click();
    });
  }
  document.addEventListener('DOMContentLoaded', () => {
    initFlickity();
    initZoomHover();
    initZoomIconTrigger();
  });

  window.ProductVisuals = {
    updateMedia
  };
})();
